<template>
  <v-text-field
    ref="control"
    class="dynamic-input-control"
    @mousedown="handleMouseDown"
    :data-id="dataId"
    :prefix="prefix"
    :suffix="suffix"
    :label="getLabel"
    :dense="dense"
    v-if="l_visible"
    :hide-details="hideDetails"
    :placeholder="placeholder"
    :readonly="readonly"
    v-model="stringValue"
    outlined
    @focus="gotfocus"
    @focusout="lostFocus"
    @change="onChange"
    :disabled="getDisabled"
    :rules="getRules"
    :loading="isLoading"
    v-bind:class="{
      dense: dense,
      validated: displayValidated && !getHasAnyError,
      required: l_required,
      'no-label': !label,
      'text-right': textRight,
      'hide-label': hideLabel,
      readonly: readonly || isDisabled || isLoading,
    }"
    :error-messages="getErrorMessages"
  >
    <template v-slot:append>
      <slot name="append" v-if="!getDisabled"></slot>
      <v-tooltip v-if="!!getTooltip && !hideTooltip" bottom max-width="350">
        <template v-slot:activator="{ on }">
          <v-icon slot="activator" class="btn-help text-body-2" v-on="on">mdi-help-circle</v-icon>
        </template>
        <span> {{ getTooltip }} </span>
      </v-tooltip>
    </template>
  </v-text-field>
</template>

<script>
import { dynamicControlMixin } from '../../mixins/dynamicControlMixin';

export default {
  mixins: [dynamicControlMixin],
  props: {
    prefix: String,
    suffix: String,
    value: Number,
    placeholder: String,
    decimalPlaces: {
      type: Number,
      default: 2,
    },
    textRight: {
      type: Boolean,
      default: false,
    },
    dense: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
    format: {
      type: Boolean,
      default: true,
    },
    minValue: {
      type: Number,
      default: null
    },
    maxValue:{
      type:Number,
      default:null
    },
    customLabel: {
      type: String,
      default: null
    },
    replaceNull:{
      type: Boolean,
      default: false
    },
    emitToParent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      stringValue: this.parseValue(this.value),
      ruleErrorMessage: null
    };
  },
  watch: {
    value(val) {
      if (this.stringValue !== this.parseValue(val)) {
        this.stringValue = this.parseValue(this.value);
        this.update();
      }
    },
    stringValue(newValue,oldValue){
      if(!this.isLoading && !this.ignoreCompare && newValue?.replace(/\s/g, '')?.replace('.', ',') != oldValue?.replace(/\s/g, '')?.replace('.', ',')){
        this.setDirty(true);
      }
      this.updateRuleErrorState();
    },
    l_minValue() {
      this.$nextTick(() => this.updateRuleErrorState());
    },
    l_maxValue() {
      this.$nextTick(() => this.updateRuleErrorState());
    }
  },
  computed:{
    getDisabled(){
      return this.disabled || this.isDisabled || this.isLoading;
    },
    getLabel(){
      return this.customLabel || this.l_label
    },
    getMinValue() {
      return this.minValue ?? this.l_minValue;
    },
    getMaxValue() {
      return this.maxValue ?? this.l_maxValue;
    },
    getHasAnyError() {
      return !!this.errorMessages || !!this.ruleErrorMessage;
    },
    getErrorMessages() {
      return this.errorMessages || this.ruleErrorMessage;
    },
  },
  methods: {
    update(){
      if(this.l_dataId == 'liw_filip__wiz_predmet__txt_oc_s_dph'){
        console.log("start update")
      }
      
      if (this.checkInput(this.stringValue) != true) {
        this.$refs.control.focus();
        this.$nextTick(() => this.updateRuleErrorState());
        return;
      }

      let num = null;
      if (this.stringValue || this.replaceNull) {
        if(this.l_dataId == 'liw_filip__wiz_predmet__txt_oc_s_dph'){
          console.log("update stringValue",this.stringValue)
        }
        let str = "";
        if(this.stringValue){
          //vymazem medzery a nahradim , za .
          str = this.stringValue.replace(/\s/g, '').replace(',', '.');
        }else{
          if(this.replaceNull){
            str = "0";
          }
        }
        
        //ziskam vyparsujem cislo zaokruhlene na x desatinnych miest
        num = parseFloat(Number(str).toFixed(this.decimalPlaces));
        //naformatujem zobrazenie
        this.stringValue = this.parseValue(num);
        if(this.l_dataId == 'liw_filip__wiz_predmet__txt_oc_s_dph'){
          console.log("update format stringValue",this.stringValue)
        }
        //updatnem hodnotu
        this.$emit('input', num);
      } else {
        if(this.l_dataId == 'liw_filip__wiz_predmet__txt_oc_s_dph'){
          console.log("update stringValue",null)
        }
        this.$emit('input', null);
      }

      this.$nextTick(() => this.updateRuleErrorState());

      if(this.l_dataId == 'liw_filip__wiz_predmet__txt_oc_s_dph'){
        console.log("update errors",!this.hasError,this.saveLoadError)
      }
      if (!this.hasError || this.saveLoadError) {
        if(this.l_dataId == 'liw_filip__wiz_predmet__txt_oc_s_dph'){
          console.log("update save",num)
        }
        this.saveValue(num);
      }
      if(this.l_dataId == 'liw_filip__wiz_predmet__txt_oc_s_dph'){
        console.log("end update")
      }
    },
    parseValue(val) {
      if (val || val === 0) {
        if (this.format) {
          return new Intl.NumberFormat('sk-SK', {
            minimumFractionDigits: this.decimalPlaces,
          }).format(val);
        } else {
          return val + '';
        }
      } else {
        return null;
      }
    },
    checkInput(val) {
      if (val || val === 0) {
        //vymazem medzery a nahradim , za .
        let str = val.replace(/\s/g, '').replace(',', '.');
        //ziskam vyparsujem cislo zaokruhlene na x desatinnych miest
        let num = parseFloat(Number(str).toFixed(this.decimalPlaces));
        //naformatujem zobrazenie

        if (isNaN(num)) return false;
      }

      return true;
    },
    gotfocus() {
      this.$emit('focus');
      if (this.stringValue) {
        this.stringValue = this.stringValue.replace(/\s/g, '').replace('.', ',');
      }
    },
    lostFocus() {
      if(this.l_dataId == 'liw_filip__wiz_predmet__txt_oc_s_dph'){
        console.log("lostFocus");
      }
      if(this.ignoreCompare){
        this.setDirty(true);
      }
      this.update();      
    },
    readData(config) {
      const newVal = this.parseValue(config.controlValue);

      if (newVal === this.stringValue) {
        this.$emit('dataLoaded');
        this.$nextTick(() => this.updateRuleErrorState());
        return;
      }

      this.stringValue = this.parseValue(config.controlValue);
      this.$emit('dataLoaded');

      if (this.checkInput(this.stringValue) != true) {
        this.$refs.control.focus();
        this.$nextTick(() => this.updateRuleErrorState());
        return;
      }

      this.$nextTick(() => this.updateRuleErrorState());
    },
    getValue() {
      if (!this.stringValue) return null;
      let str = this.stringValue.replace(/\s/g, '').replace(',', '.');
      return parseFloat(Number(str).toFixed(this.decimalPlaces));
    },
    setValue(val) {
      this.stringValue = val;
      if(this.l_dataId == 'liw_filip__wiz_predmet__txt_oc_s_dph'){
        console.log("setvalue" ,val);
      }
      this.setDirty(true);
    },
    onChange() {
      this.$emit('change');
    },
    updateRuleErrorState() {
    if(!this.emitToParent) return;
      const control = this.$refs.control;
      if (!control) return;

      control.validate();
      this.ruleErrorMessage = control.errorBucket?.[0] ?? null;

      this.$emit('validationChanged', this.ruleErrorMessage);
    },
  },
  created() {
    this.addRule(v => this.checkInput(this.stringValue) || 'Zadané číslo nie je správne !');
    this.addRule(v =>{
      let str = (this.stringValue + "")
      str =  str.replace(/\s/g, "");
      return str == null || str?.length < (10 + this.decimalPlaces) || 'Hodnota nesmie obsahovať viac ako ' + (9 +this.decimalPlaces ) + ' znakov.';
    } );
    
    this.addRule(v => {
      if (v == null || v === '') return true;
      if (this.getMinValue == null) return true;

      let str = (v + '').replace(/\s/g, '').replace(',', '.');
      let num = parseFloat(Number(str).toFixed(this.decimalPlaces));

      let errorText = this.getMaxValue != null ? `Povolená je hodnota v rozsahu ${this.getMinValue} až ${this.getMaxValue}.` : 'Hodnota nemôže byť menšia ako ' + this.getMinValue + '.';

      return isNaN(num) || num >= Number(this.getMinValue) || errorText;
    });

    this.addRule(v => {
      if (v == null || v === '') return true;
      if (this.getMaxValue == null) return true;

      let str = (v + '').replace(/\s/g, '').replace(',', '.');
      let num = parseFloat(Number(str).toFixed(this.decimalPlaces));

      let errorText = this.getMinValue != null ? `Povolená je hodnota v rozsahu ${this.getMinValue} až ${this.getMaxValue}.` : 'Hodnota nemôže byť väčšia ako ' + this.getMaxValue + '.';

      return isNaN(num) || num <= Number(this.getMaxValue) || errorText;
    });
  },
};
</script>
